<template>
    <v-card>
        <v-card-title>請勾選您想顯示的資料
            <v-spacer></v-spacer>
                <v-btn small color="red lighten-2" @click="saveSetting">完成</v-btn>
            </v-card-title>
        <v-list style="max-height: 400px" class="overflow-y-auto">
            <div v-for="(field, index) in selectedHeaders" :key="index">
                <v-list-item :class="[{'blue lighten-5': field.selected }, 'white']">
                    <v-list-item-action>
                        <v-checkbox v-model="field.selected"></v-checkbox>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>{{field.text}}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                 <v-divider v-if="index + 1 < selectedHeaders.length"></v-divider> 
            </div>
        </v-list>
    </v-card>
</template>
<script>
import {mapGetters, mapMutations} from 'vuex';
export default {
    data(){
        return {
            headers:[],
            selectedHeaders:[],
        }
    },
    computed:{
        ...mapGetters('holderlist',[
            'getSelectedHolderListHeaders',
            'getAllHolderListHeaders',
        ]),
        getSelectedHeaderList(){
            return this.selectedHeaders.filter(field => {
                                        if (field.selected === true) {
                                        return field
                                        }
                                    });
        }
    },
    methods:{
        ...mapMutations('holderlist',[
            'setSelectedHolderListHeaders'
        ]),
        saveSetting(){
            console.log(this.getSelectedHeaderList,'getSelectedHolderListHeaders')
            this.setSelectedHolderListHeaders(this.getSelectedHeaderList)
            console.log(this.getSelectedHeaderList,'getSelectedHolderListHeaders')
            
            //父元件須要去指定@ChangeDialogShowSettingEvent所設定的方法，該方法必須要指定參數。
            //此事件用來觸發Dialog關閉
            this.$emit('ChangeDialogShowSettingEvent', false)
        },
    },
    created(){
        this.selectedHeaders = this.getAllHolderListHeaders
    }
}
</script>
